import * as React from "react";
import { withRouter } from "react-router";
import { RouterState } from "react-router-redux";

import Nav from "./Nav";
import { default as NavItem, NavItemProps } from "./NavItem";
import * as constants from "./constants";

interface NavContainerProps extends RouterState {
  fullWidth?: boolean;
  hasShadow?: boolean;
  navRoutes?: NavItemProps[];
}

interface NavContainerState {
  collapsed: boolean;
}

class NavContainer extends React.Component<
  NavContainerProps,
  NavContainerState
> {
  private toggleBtn: HTMLButtonElement;

  public static defaultProps: Partial<NavContainerProps> = {
    navRoutes: constants.NAV_ROUTES,
  };

  public state: NavContainerState = {
    collapsed: true,
  };

  public componentDidMount() {
    document.addEventListener("click", this.handleDocumentClick, false);
  }

  public componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick, false);
  }

  private assignRef = (element: HTMLButtonElement) => {
    this.toggleBtn = element;
  };

  private handleDocumentClick = event => {
    if (!this.toggleBtn.contains(event.target)) {
      this.setState(state => ({
        ...state,
        collapsed: true,
      }));
    }
  };

  private toggleCollapse = () =>
    this.setState(state => ({
      ...state,
      collapsed: !this.state.collapsed,
    }));

  private isActive = ({ to }: NavItemProps): boolean =>
    this.props.location == null
      ? false
      : `${this.props.location.pathname}${this.props.location.hash}` === to;

  private renderNavItems = () =>
    (this.props.navRoutes as NavItemProps[]).map((props, i) => (
      <NavItem key={i} {...props} active={this.isActive(props)} />
    ));

  public render() {
    return (
      <Nav
        {...this.props}
        {...this.state}
        toggleCollapse={this.toggleCollapse}
        assignRef={this.assignRef}
      >
        {this.renderNavItems()}
      </Nav>
    );
  }
}

export default withRouter(NavContainer);



// WEBPACK FOOTER //
// ./src/layouts/Main/NavContainer.tsx